import MetodosGenerales from '@/utils/metodosgenerales.vue.js';

export default {
    async Telefonos(vm){
        let datos = await MetodosGenerales.obtenerSessionReporte('reporte');
        var datosReporte = new FormData();
        datosReporte.append("nrreporte", datos.nrreporte);
        datosReporte.append("svindice", datos.svindice);
        return vm.axios.post(`${vm.domain.domainNameForApi}Telefonos/DetalleTelefonos`, datosReporte).then(response => response.data);
    },
}